(function($, Drupal) {
  /**
   * Add new command.
   */
  Drupal.AjaxCommands.prototype.updatePnrAndName = function(ajax, response, status){
    $("form input#my-account-get-pnr-pnr").val(response.pnr);
    $("form #my-account-get-pnr-lastname").val(response.lastName);
  };

  Drupal.AjaxCommands.prototype.updateMaps = function(ajax, response, status){
    initMap();
  };

})(jQuery, Drupal);